export const CHALLENGE_DEFAULT_BANNER = {
  WEB: 'https://content.lifebase.solutions/challenges/default-banner-desktop.jpg',
  MOBILE: 'https://content.lifebase.solutions/challenges/default-banner-mobile.jpg',
};
